import React, { memo } from 'react'

import NftList from './NftList'

const Nfts = ({ nfts, onSelectNft, t, loadingNftBalance }) => {
  return (
    <NftList
      nfts={nfts}
      onSelectNft={onSelectNft}
      loadingNftBalance={loadingNftBalance}
      t={t}
    />
  )
}

export default memo(Nfts)
